import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "../components/ui/select";
import { ADMIN_CATEGORIES, publishArticle } from "../lib/articlesApi";

const initialForm = {
  title: "",
  category: "",
  summary: "",
  content: "",
  sourceUrl: "",
  publishedAt: ""
};

export function AdminDashboardPage() {
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const onPublish = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      await publishArticle(form);
      setSuccess("Artigo publicado com sucesso.");
      setForm(initialForm);
    } catch (err) {
      setError(err.message || "Erro ao publicar.");
    } finally {
      setLoading(false);
    }
  };

  const onLogout = async () => {
    await fetch("/api/admin/logout", { method: "POST", credentials: "same-origin" });
    navigate("/admin");
  };

  return (
    <main className="min-h-screen bg-[#faf9f7] pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="flex flex-wrap gap-4 items-center justify-between mb-8">
          <div>
            <h1 className="font-serif text-4xl text-[#1a1a1a]">Painel Administrativo</h1>
            <p className="text-slate-600 mt-2">Cadastrar novo artigo em `/data/artigos.json`.</p>
          </div>
          <Button type="button" variant="outline" onClick={onLogout}>
            Sair
          </Button>
        </div>

        <form onSubmit={onPublish} className="bg-white rounded-2xl border border-[#d4af37]/15 shadow-sm p-8 space-y-6">
          <div className="space-y-2">
            <Label htmlFor="title">Título</Label>
            <Input id="title" name="title" value={form.title} onChange={onChange} required />
          </div>

          <div className="space-y-2">
            <Label htmlFor="category">Categoria</Label>
            <Select
              value={form.category}
              onValueChange={(value) => setForm((prev) => ({ ...prev, category: value }))}
            >
              <SelectTrigger id="category">
                <SelectValue placeholder="Selecione a categoria" />
              </SelectTrigger>
              <SelectContent>
                {ADMIN_CATEGORIES.map((category) => (
                  <SelectItem key={category} value={category}>
                    {category}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="summary">Resumo</Label>
            <Textarea id="summary" name="summary" value={form.summary} onChange={onChange} rows={3} required />
          </div>

          <div className="space-y-2">
            <Label htmlFor="content">Conteúdo</Label>
            <Textarea id="content" name="content" value={form.content} onChange={onChange} rows={8} required />
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="sourceUrl">Link da fonte</Label>
              <Input
                id="sourceUrl"
                name="sourceUrl"
                type="url"
                placeholder="https://..."
                value={form.sourceUrl}
                onChange={onChange}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="publishedAt">Data de publicação</Label>
              <Input
                id="publishedAt"
                name="publishedAt"
                type="date"
                value={form.publishedAt}
                onChange={onChange}
                required
              />
            </div>
          </div>

          {error && <p className="text-sm text-red-600">{error}</p>}
          {success && <p className="text-sm text-green-700">{success}</p>}

          <Button type="submit" className="bg-[#d4af37] hover:bg-[#b8962e] text-[#1a1a1a]" disabled={loading}>
            {loading ? "Publicando..." : "Publicar"}
          </Button>
        </form>
      </div>
    </main>
  );
}
